module.exports = __webpack_public_path__ + "img/light.6aed70d2.svg";